<template>
<div class="card"
  :id="group.itemId">
  <div class="card-header">{{ group.heading }}</div>
  <component v-for="(item, index) in group.items"
    v-bind:is="getCardComponent(item.componentName)"
    v-bind:item="item"
    v-bind:itemIndex="index"
    v-bind:groupIndex="groupIndex"
    :index="index">
  </component>
  <div class="page-break-switch">
    <span class="text">改ページ</span>
    <i-switch v-model="group.pageBreak" />
    <!--<span class="text">{{ group.pageBreak }}</span>-->
  </div>
</div>
</template>

<script>
import cardIndex from '@/assets/card/index'
export default {
  data() {
    return {}
  },
  props: ['group', 'groupIndex'],
  computed: {},
  mounted: function () {},
  methods: {
    getCardComponent: function (componentName) {
      return cardIndex[componentName].edit
    }
  }
}
</script>
